module.exports = __webpack_public_path__ + "img/BD.6226d226.png";